import { Indicator, type IndicatorProps as MantineIndicatorProps } from "@mantine/core";
import clsx from "clsx";
import React from "react";
import styles from "./SidebarIndicatorBadge.module.scss";
import type { BadgeColor, BadgeVariant } from "./SidebarIndicatorBadge.types";

type SidebarIndicatorBadgeProps = {
  position: MantineIndicatorProps["position"];
  badgeCount: number;
  children?: React.ReactNode;
  color?: BadgeColor;
  variant?: BadgeVariant;
  offset?: number;
  size?: number;
};

export default function SidebarIndicatorBadge({
  position,
  badgeCount,
  children,
  color = "success",
  variant = "highContrast",
  offset = 6,
  size = 18,
}: SidebarIndicatorBadgeProps) {
  const colorClass = clsx(styles.indicator, styles[variant], styles[color]);
  return (
    <Indicator
      position={position}
      inline
      size={size}
      radius="xl"
      offset={offset}
      disabled={!badgeCount}
      classNames={{
        indicator: colorClass,
      }}
      label={<span>{badgeCount}</span>}
    >
      {children}
    </Indicator>
  );
}
